import React from "react";

class ScrollToTop extends React.PureComponent {
  render() {
    function scrollToTop() {
      window.scrollTo({ top: 0 });
    }

    return (
      <div style={{ height: "60px" }}>
        <div
          className="shadow rounded-tl fixed bottom-0 right-0 cursor-pointer bg-gray-800 p-4 text-2xl text-white hover:bg-gray-900"
          onClick={scrollToTop}
        >
          ⤒
        </div>
      </div>
    );
  }
}

export default ScrollToTop;
